import React from "react";
import { Link } from "react-router-dom";
import aboutBg from "../Assets/IMG/about-bg.jpg";
import ArrowRightIcon from "../Assets/icon/arrow-right.svg";
import Carousel from "../Pages/Carousel";
import doctorStrange from "../Assets/IMG/Doctor Strange.png";
import sectionBg from "../Assets/IMG/BG_01.gif";


const Mafia = () => {
  return (
    <>
      {/* Responsive Styles */}
      <style>{`
        @media (max-width: 1024px) {
          .mafia-heading {
            font-size: 40px !important;
          }
          .mafia-paragraph {
            font-size: 18px !important;
            padding: 0 1rem;
          }
        }

        @media (max-width: 600px) {
          .mafia-heading {
            font-size: 32px !important;
          }
          .mafia-paragraph {
            font-size: 14px !important;
          }
        }
      `}</style>

      {/* Top Hero Section */}
      <section
        style={{
          backgroundImage: `url(${aboutBg})`,
          backgroundSize: "cover",
          textAlign: "center",
          padding: "30px 20px",
          color: "#fff",
          maxHeight: "659px",
        }}
      >
        <h1 className="mafia-heading" style={{ fontSize: "40px", fontWeight: "700" }}>
          Not All Heroes Wear <br />
          Capes Some Build Brands
        </h1>
        <p
          className="mafia-paragraph"
          style={{
            maxWidth: "700px",
            margin: "20px auto",
            fontSize: "15.9px",
            lineHeight: "1.8",
            fontWeight: "500",
          }}
        >
          AT GLOWINGROWTH MEDIA, WE'RE NOT JUST THE BEST DIGITAL MARKETING AGENCY IN PUNE —
          WE'RE YOUR CREATIVE AVENGERS. FROM SOCIAL MEDIA MARKETING TO REELS PRODUCTION,
          SEO, ADS MANAGE-<br/>MENT, AND WEBSITE DEVELOPMENT, WE BUILD BRANDS THAT BREAK THROUGH
          THE NOISE AND GROW 3X IN 100 DAYS. POWERED FROM KARVENAGAR, TRUSTED BY 850+ CLIENTS, AND BUILT FOR IMPACT.
        </p>
      </section>

      {/* Strategy Section */}
      <section
        style={{
          backgroundImage: `url(${sectionBg})`,
          padding: "20px 20px",
        }}
      >
        {/* Section Heading */}
        <h1
          className="mafia-heading"
          style={{
            fontSize: "50px",
            fontWeight: "900",
            textAlign: "center",
            marginBottom: "40px",
            lineHeight: "1.4",
            color:"#191e34"
          }}
        >
          WHERE STRATEGY MEETS SORCERY <br /> AND GROWTH GETS REAL
        </h1>

        {/* Flex Container for Image & Text */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "5%",
            flexWrap: "wrap",
          }}
        >
          {/* Image */}
          <div style={{ flex: "1 1 300px", maxWidth: "200px", textAlign: "center" }}>
            <img
              src={doctorStrange}
              alt="Doctor Strange"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </div>

          {/* Text */}
          <div style={{ flex: "1 1 400px", maxWidth: "700px",marginTop:"-50px" }}>
            <p
              className="mafia-paragraph"
              style={{ fontSize: "22px", fontWeight: "600", lineHeight: "1.6",color:"#2b2e42"  }}
            >
              At Glowingrowth Media, we’re kind of like Doctor Strange with a laptop opening
              portals to 3X growth using smart social media marketing, slick ads management, and
              scroll-stopping video production. Need a stunning website?
            </p>
            <p
              className="mafia-paragraph"
              style={{ fontSize: "22px", fontWeight: "600", lineHeight: "1.6", marginTop: "15px",color:"#2b2e42"  }}
            >
              We’ve got you. Want your brand to pop in Karvenagar, Pune, or the whole dang internet?
              Done. We mix creativity, strategy, and a bit of marketing magic to turn your brand
              into the hero of its own story. Because let’s face it your business deserves more
              than just likes. It deserves a legacy.
            </p>
          </div>
        </div>

        <Carousel/>
      </section>
    </>
  );
};

export default Mafia;
